// =============================================================================
// features/configuracoes/comercial/AttemptsSection.tsx — Grupo "Tentativas"
// (doc 26 §6.9): máximo de tentativas + intervalo mínimo entre elas.
// =============================================================================

import * as React from 'react';

import { Input } from '../../../components/ui/Input';

import { SettingsCard } from './SettingsCard';
import type { DraftErrors, SettingsDraft } from './types';

interface AttemptsSectionProps {
  draft: SettingsDraft;
  errors: DraftErrors;
  isDefault: boolean;
  onChange: (updates: Partial<SettingsDraft>) => void;
  disabled?: boolean;
}

function formatMinutes(minutes: number): string {
  if (minutes === 0) return 'sem intervalo mínimo';
  if (minutes % 1440 === 0) return `${minutes / 1440} dia${minutes / 1440 !== 1 ? 's' : ''}`;
  if (minutes % 60 === 0) return `${minutes / 60} hora${minutes / 60 !== 1 ? 's' : ''}`;
  return `${minutes} minutos`;
}

export function AttemptsSection({
  draft,
  errors,
  isDefault,
  onChange,
  disabled = false,
}: AttemptsSectionProps): React.JSX.Element {
  return (
    <SettingsCard
      title="Tentativas"
      description="Quantas vezes tentar contatar o mesmo lead e quanto tempo esperar entre tentativas."
      isDefault={isDefault}
    >
      <div className="grid grid-cols-2 gap-4">
        <Input
          id="comercial-max-attempts"
          label="Tentativas máximas"
          type="number"
          min={1}
          max={30}
          value={draft.maxAttempts}
          disabled={disabled}
          error={errors.maxAttempts}
          onChange={(e) => onChange({ maxAttempts: parseInt(e.target.value, 10) || 0 })}
        />
        <Input
          id="comercial-min-interval"
          label="Intervalo mínimo (minutos)"
          type="number"
          min={0}
          max={10080}
          value={draft.minIntervalMinutes}
          disabled={disabled}
          error={errors.minIntervalMinutes}
          hint={errors.minIntervalMinutes ? undefined : formatMinutes(draft.minIntervalMinutes)}
          onChange={(e) => onChange({ minIntervalMinutes: parseInt(e.target.value, 10) || 0 })}
        />
      </div>
    </SettingsCard>
  );
}
